<template>
  <div id="my-node" style="padding-bottom: 125px;">
    <v-container fluid>
      <v-row>
        <v-col lg="12">
          <v-card v-if="viewSkeletonsP" :color="whitesmoke">
            <v-col cols="12">
              <div :class="skeletonTitleP" :style="backgroundSkeleton"></div>
            </v-col>
            <v-col cols="12">
              <div
                :class="skeletonColumnP"
                :style="backgroundSkeleton + 'height: 150px !important;'"
              ></div>
            </v-col>
          </v-card>

          <v-card height="100%" v-else>
            <!-- GENERAL -->
            <v-card-title class="subtitle3Text">GENERAL</v-card-title>
            <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>
            <v-card-text>
              <v-container style="padding:0">
                <v-row class="mb-5" no-gutters style="margin-bottom: 0px !important;">
                  <v-col sm="12" lg="3" md="6" xs="12" cols="12">
                    <v-card class="pa-2" tile :style="styleCard">
                      <v-row
                        class="subtitle4Text mb-1"
                        no-gutters
                      >{{ $t("vehicle") }}</v-row>
                      <v-row class="regularText mb-1" no-gutters>
                        <v-icon class="icon-size pr-2" :color="colorTheme">mdi-truck</v-icon>
                        {{ nickId + " (" + vehicleId + ")" }}
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col sm="12" lg="3" md="6" xs="12" cols="12">
                    <v-card class="pa-2" tile :style="styleCard">
                      <v-row
                        class="subtitle4Text mb-1"
                        no-gutters
                      >{{ $t("periodTitle") }}</v-row>
                      <v-row class="regularText mb-1" no-gutters>
                        <v-icon class="icon-size pr-2" :color="colorTheme">mdi-calendar</v-icon>
                        {{ startDate + " " + $t("to") + " " + endDate }}
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col sm="12" lg="3" md="6" xs="12" cols="12">
                    <v-card class="pa-2" tile :style="styleCard">
                      <v-row
                        class="subtitle4Text mb-1"
                        no-gutters
                      >{{ $t("finalOdometer") }}</v-row>
                      <v-row class="regularText mb-1" no-gutters>
                        <v-icon class="icon-size pr-2" :color="colorTheme">mdi-speedometer</v-icon>
                        {{ finalOdometer }}
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col sm="12" lg="3" md="6" xs="12" cols="12">
                    <v-card class="pa-2" tile :style="styleCard">
                      <v-row
                        class="subtitle4Text mb-1"
                        no-gutters
                      >{{ $t("finalFuel") }}</v-row>
                      <v-row class="regularText mb-1" no-gutters>
                        <v-icon class="icon-size pr-2" :color="colorTheme">mdi-gas-station</v-icon>
                        {{ finalFuel }}
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row class="mb-5" no-gutters>
                  <v-col sm="12" lg="3" md="6" xs="12" cols="12">
                    <v-card class="pa-2" tile :style="styleCard">
                      <v-row
                        class="subtitle4Text mb-1"
                        no-gutters
                      >{{ $t("periodOfEvents") }}</v-row>
                      <v-row class="regularText mb-1" no-gutters>
                        <v-icon class="icon-size pr-2" :color="colorTheme">mdi-calendar</v-icon>
                        {{ intervalStart + " " + $t("to") + " " + intervalEnd }}
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col sm="12" lg="3" md="6" xs="12" cols="12">
                    <v-card class="pa-2" tile :style="styleCard">
                      <v-row
                        class="mb-1"
                        no-gutters
                      >{{ $t("trip") }}</v-row>
                      <v-row no-gutters>
                        <v-select
                        dense
                          outlined
                          style="height: 50px"
                          :items="listOfTrips"
                          item-text="name"
                          :label="trips"
                          v-model="selectedTripP"
                          @change="checkTrip"
                          item-value="id"
                        ></v-select>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col sm="12" lg="3" md="6" xs="12" cols="12">
                    <v-card class="pa-2" tile :style="styleCard">
                      <v-row class="ml-lg-3 mt-5 pt-2" no-gutters>
                        <v-col cols="auto">
                          <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-if="this.$store.state.production == false"
                                  :color="colorTheme"
                                  dark
                                  :style="'height: 40px;margin-right: 15px;'"
                                  v-on:click="goToComparative()"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon rigth dark style>mdi-chart-bar-stacked</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("compare").toUpperCase() }}</span>
                            </v-tooltip>

                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  :color="colorTheme"
                                  dark
                                  :style="'height: 40px;width: 50px;margin-right: 15px;'"
                                  v-on:click="toExcelData()"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon rigth dark style>mdi-file-excel</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("expExcel").toUpperCase() }}</span>
                            </v-tooltip>

                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  :color="colorTheme"
                                  dark
                                  :style="'height: 40px;width: 50px;margin-right: 15px;'"
                                  v-on:click="printDashboard()"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon rigth dark style>mdi-image-area</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("expDash").toUpperCase() }}</span>
                            </v-tooltip>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- CÁLCULOS GLOBALES -->
        <v-col cols="12" class="subtitle3Text" style="text-align: start;">{{ $t("calGlobal").toUpperCase() }}</v-col>

        <v-row style="display: contents;">
          <template v-for="(item, index) in ItemsPerformance">
            <v-col
              :cols="10"
              lg="2"
              md="4"
              sm="5"
              xs="10"
              style="text-align: initial; line-height: normal;min-width: 130px;"
              v-bind:key="index"
            >
              <v-card
                height="135px"
                style="display: grid;"
                v-if="viewSkeletonsP"
                :color="whitesmoke"
              >
                <v-col cols="12">
                  <div :class="skeletonP" :style="backgroundSkeleton"></div>
                </v-col>
                <v-col cols="12">
                  <div :class="skeletonP" :style="backgroundSkeleton"></div>
                </v-col>
              </v-card>

              <v-card height="135px" style="display: grid;" :color="whitesmoke" v-else>
                <v-row style="display: contents;">
                  <v-divider
                    light
                    vertical
                    :color="colorTheme"
                    style="position: absolute;border-width: 2px;"
                  ></v-divider>
                  <v-col cols="12">
                    <div class="regularText">{{ item.title }}</div>
                  </v-col>
                  <v-col cols="12">
                    <div
                      class="cardValueText font-weight-medium my-2;"
                    >{{ item.value }}</div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </template>
        </v-row>

        <!--JEMA-->
        <v-col cols="12" class="subtitle3Text" style="text-align: start;">{{ $t("tripEfficiency").toUpperCase() }}</v-col>
        <v-row justify="space-around" style="display: contents;">
          <template v-for="(item, index) in itemsTravelEfficiencyCharts">
            <v-col sm="12" lg="4" md="6" cols="12" v-bind:key="index">
              <v-card v-if="viewSkeletonsP" :color="whitesmoke">
                <v-col cols="12">
                  <div :class="skeletonTitleP" :style="backgroundSkeleton"></div>
                </v-col>
                <v-col cols="12">
                  <div :class="skeletonPieP" :style="backgroundSkeleton"></div>
                </v-col>
                <v-col cols="12">
                  <div :class="skeletonFooterP" :style="backgroundSkeleton"></div>
                </v-col>
              </v-card>
              <v-card :color="whitesmoke">
                <highcharts :id="item.title"></highcharts>
              </v-card>
            </v-col>
          </template>
        </v-row>

        <v-col cols="12" class="subtitle3Text" style="text-align: start;">
          {{
          $t("efficiencyAnalisis").toUpperCase()
          }}
        </v-col>
        <v-row style="display: contents;">
          <v-col cols="12">
            <v-card v-if="viewSkeletonsP" :color="whitesmoke">
              <v-col cols="12">
                <div :class="skeletonTitleP" :style="backgroundSkeleton"></div>
              </v-col>
              <v-col cols="12">
                <div :class="skeletonColumnP" :style="backgroundSkeleton"></div>
              </v-col>
              <v-col cols="12">
                <div :class="skeletonTitleP" :style="backgroundSkeleton"></div>
              </v-col>
              <v-col cols="12">
                <div :class="skeletonColumnP" :style="backgroundSkeleton"></div>
              </v-col>
            </v-card>
            <v-card>
              <v-card-text>
                <div style="width:100%;" id="containerPerformance"></div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-col
          cols="12"
          class="subtitle3Text" 
          style="text-align: start;"
        >{{ $t("titleExceptions").toUpperCase() }}</v-col>
        <v-row style="display: contents;">
          <template v-for="(item, index) in ItemsExceptions">
            <v-col
              cols="10"
              lg="6"
              md="6"
              sm="12"
              xs="12"
              style="text-align: initial; line-height: normal;min-width: 130px;"
              v-bind:key="index"
            >
              <v-card>
                <v-card-title
                  class="subtitle4Text"
                >{{ item.title.toUpperCase() }}</v-card-title>
                <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>

                <v-card-text v-if="viewSkeletonsP">
                  <v-container>
                    <v-row justify="center">
                      <v-col style="width:100%;" sm="12" lg="6" md="6" cols="12">
                        <v-row style="width:100%;" justify="center">
                          <v-col cols="12" style="text-align: center;">
                            <div :class="skeletonPieP" :style="backgroundSkeleton"></div>
                          </v-col>
                          <v-col cols="12">
                            <div :class="skeletonP" :style="backgroundSkeleton"></div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-text v-else>
                  <v-container>
                    <v-row justify="center">
                      <v-col sm="12" lg="6" md="6" cols="12">
                        <v-row justify="center">
                          <div style="width: 100%;height: 420px;" :id="item.container"></div>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </template>
        </v-row>

        <v-col cols="12" class="subtitle3Text" style="text-align: start;">
          {{
          $t("distribution").toUpperCase()
          }}
        </v-col>

        <v-col lg="12" md="12" sm="12" v-if="!print">
          <v-card :color="whitesmoke" v-show="viewSkeletonsP">
            <v-col cols="12">
              <div :class="skeletonTitleP" :style="backgroundSkeleton"></div>
            </v-col>
            <v-col cols="12">
              <div
                :class="skeletonColumnP"
                :style="backgroundSkeleton + 'height: 590px !important;'"
              ></div>
            </v-col>
          </v-card>
          <v-card v-show="!viewSkeletonsP">
            <v-card-title class="subtitle4Text">
              {{
              $t("titleExceptions")
              }}
            </v-card-title>
            <v-card-text class="pa-0">
              <div id="mapPerformance" style="width: 100%; height: 590px"></div>
            </v-card-text>
            
          </v-card>
        </v-col>

        <v-col cols="12" class="subtitle3Text" style="text-align: start;">
          {{
          $t("exceptionsReport").toUpperCase()
          }}
        </v-col>
        <v-col sm="4" lg="3" cols="12" class="pb-5" style="max-height: 60px;">
            <v-text-field
              solo
              :label="$t('search')"
              append-icon="mdi-magnify"
              single-line
              v-model="search"
              :color="colorTheme"
            ></v-text-field>
          </v-col>
          <v-col lg="2" md="3" sm="4" cols="12" class="pb-5">
            <v-btn
              style="width: 100%; margin: 0;"
              large
              :color="colorTheme"
              class="regularText white--text"
              v-on:click="toExcel()"
            >
              {{ $t("download").toUpperCase() }}
              <v-icon class="icon-size pl-4" right dark>mdi-cloud-download</v-icon>
            </v-btn>
          </v-col>
          <v-col lg="12" md="12" sm="12">
            <v-data-table
              :no-data-text="$t('noResults')"
              :headers="headersPerformance"
              :items="itemsTableInTransit2"
              :search="search"
              :items-per-page="5"
              :loading="progressPerformance"
              :loading-text="$t('loadingTextForTable')"
              class="elevation-1 tableIntransit myTableTD myTableFooter"
              sort-by="DateTimestamp"
              :sort-desc="true"
              :footer-props="{
                'items-per-page-text': $t('rows'),
                'items-per-page-all-text': $t('all')
              }"
              @click:row="handleRowClick"
            >
              <template v-slot:item.DateTimestamp="{ item }">
                <span>{{ item.DateFormatted }}</span>
              </template>

              <template v-slot:item.Reference="{ item }">
                <v-btn text small class="text-decoration-underline" :color="colorTheme" @click="getReference($event, item)">
                  {{ item.Reference }}
                </v-btn>
              </template>

              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="mdi-alert"
              >{{ $t("noResults") }} : "{{ search }}".</v-alert>
              <template
                v-slot:footer.page-text="items"
              >{{ items.pageStart }} - {{ items.pageStop }} {{$t("of").toLowerCase()}} {{ items.itemsLength }}</template>
            </v-data-table>
          </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
import Highcharts from "highcharts";
import Axios from "axios";
import domtoimage from "dom-to-image";
import $ from "jquery";
import moment from "moment";
import html2canvas from "html2canvas";

export default {
  name: "performance",
  components: {
    highcharts: Chart
  },
  data() {
    return {
      trips: "",
      ItemsExceptions: [],
      itemsDashboardInfo: [],
      styleCard: " -webkit-box-shadow: none;box-shadow: none;",
      rowStyle: "margin-bottom: 5px!important;",
      search: "",
      itemsTravel: [],
      newItems: [],
      progressPerformance: false,
      itemsPerformance1: {},
      startDate: "",
      endDate: "",
      vehicleId: "",
      nickId: "",
      engine: [],
      engine1: [],
      percentUsage: [],
      percentUsage1: [],
      categories: [],
      selectedTripP: {},
      print: false
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.$store.commit("setTitle", "ALERTRUCK");
    this.$store.commit("skeletonP", "outskeleton");
    this.$store.commit("skeletonTitleP", "outskeletonTitle");
    this.$store.commit("skeletonPieP", "outskeletonPie");
    this.$store.commit("skeletonFooterP", "outskeletonFooter");
    this.$store.commit("skeletonColumnP", "outskeletonColumn");

    //iveet
    this.ItemsExceptions = [
      {
        title: this.$t("driving"),
        container: "container1"
      },
      {
        title: this.$t("operation"),
        container: "container2"
      },
      {
        title: this.$t("logistic"),
        container: "container3"
      },
      {
        title: this.$t("diagnosticUnit"),
        container: "container4"
      }
    ];
    localStorage.setItem("selectedTrips", this.$t("all"));
    this.trips = this.$t("trip");
    this.selectedTripP = { name: this.$t("all"), id: 0 };
    var myTitle = JSON.parse(localStorage.getItem("mytitle"));
    if (this.$store.state.titleGraphic == "") {
      this.$store.commit("titleOfGraphic", myTitle);
    }
    this.$store.commit("setPageHeader", [
      this.$t("dashboard"),
      this.$store.state.PageHeaderGraphTitle.toUpperCase(),
      this.$t("performance"),
      "",
      true
    ]);
  },
  mounted() {
    this.$store.dispatch("getItemsIP");
    this.setData();
    this.$store.commit("backgroundSkeleton");
  },
  watch: {},
  computed: {
    ...mapState([
      "itemsTravelEfficiencyCharts",
      "colorTheme",
      "backgroundSkeleton",
      "whitesmoke",
      "headersPerformance",
      "itemsTableInTransit2",
      "ItemsPerformance",
      "itemsDashboardCharts",
      "viewSkeletonsP",
      "start",
      "listOfTrips",
      "btnDisableds",
      "btnDisabled",
      "finalOdometer",
      "finalFuel",
      "intervalStart",
      "intervalEnd",
      "valueDeterminate"
    ]),
    skeletonP: {
      get: function() {
        return this.$store.state.skeletonP;
      },
      set: function() {}
    },
    skeletonTitleP: {
      get: function() {
        return this.$store.state.skeletonTitleP;
      },
      set: function() {}
    },
    skeletonPieP: {
      get: function() {
        return this.$store.state.skeletonPieP;
      },
      set: function() {}
    },
    skeletonFooterP: {
      get: function() {
        return this.$store.state.skeletonFooterP;
      },
      set: function() {}
    },
    skeletonColumnP: {
      get: function() {
        return this.$store.state.skeletonColumnP;
      },
      set: function() {}
    }
  },
  methods: {
    //Función para mostrar en mapa el evento de la fila seleccionada
    async handleRowClick(rowData) {
      let validateCoordinates = this.$store.getters.isValidLatLon({ lat: rowData.Lat, lon: rowData.Lon });
      if (validateCoordinates) {
        //como no tenemos IdReporte, se validará coincidencia con Id de evento, fecha y detalles de evento
        let event = this.$store.state.itemsTableInTransit2.find(event => (event.EventId === rowData.EventId) && (event.DateTimestamp === rowData.DateTimestamp) && (event.Details === rowData.Details));
        if (event) {
          this.$store.dispatch("CenterMap", {miLat: event.Lat, miLng: event.Lon});

          //scroll to map
          let mapElement = document.getElementById('mapPerformance');
          mapElement.scrollIntoView(false);
        }

      } else {
        this.$store.commit("snackbar", { snackbar: true, text: i18n.t("mapCoordinatesError")});
      }
    },

    //Función para obtener referencia o mostrar ubicación en mapa
    getReference(event, item) {
      event.stopPropagation();
      if (item.Reference == i18n.t("showReference")) {
        this.$store.dispatch("getReferenceDataForTable", item);
      } else {
       this.handleRowClick(item);
      }
    },

    checkTrip(val) {
      // console.log(val);
      if (val != this.$t("all")) {
        localStorage.setItem("selectedTrips", val);
      } else {
        localStorage.setItem("selectedTrips", this.$t("all"));
      }
      if (this.$store.state.listOfTrips.length > 2) {
        this.setDataByTrip();
      }
    },
    toExcel() {
      this.$store.dispatch("exportExcelInTransit");
    },
    //iveet
    printDashboard() {
      var vm = this;
      this.print = true;
      var vehicle = this.nickId;
      var node = document.getElementById("my-node");
      domtoimage
        .toBlob(document.getElementById("my-node"))
        .then(function(blob) {
          window.saveAs(blob, "AT-Performance." + vehicle + ".png");
          vm.print = false;
          setTimeout(() => {
            vm.$store.dispatch("performanceMap");
          }, 1000);
        }).catch(function (error) {
          console.error('oops, something went wrong!', error);
          vm.$store.dispatch("performanceMap");
        });
    },
    setData() {
      var lang = localStorage.getItem("language");
      this.itemsDashboardInfo = JSON.parse(
        localStorage.getItem("ItemsDashboard")
      );

      //get dates datesCalendar1 y 2 endClock startClock
      var sDate = localStorage.getItem("datesCalendar1");
      var eDate = localStorage.getItem("datesCalendar2");
      var sClock = localStorage.getItem("startClock");
      var eClock = localStorage.getItem("endClock");
      sClock = sClock == null || sClock == undefined ? "00:00" : sClock;
      this.startDate = sDate + " " + sClock;
      eClock = eClock == null || eClock == undefined ? "23:59" : eClock;
      this.endDate =
        eDate == undefined || eDate.length == 0
          ? sDate + " " + eClock
          : eDate + " " + eClock;

      this.startDate = this.$store.getters.formatDateCustom(this.startDate);
      this.endDate = this.$store.getters.formatDateCustom(this.endDate);

      var vehicle = localStorage.getItem("performanceVehicle");
      vehicle = vehicle.split("@");
      this.nickId = vehicle[0];
      this.vehicleId = vehicle[1];
    },
    async setDataByTrip() {
      var tripId = localStorage.getItem("selectedTrips");
      if (tripId != this.$t("all")) {
        localStorage.setItem("byTrip", true);

        this.$store.dispatch("getPerformanceByTrip", tripId);
        // console.log(tripId);
      } else {
        var bytrip = localStorage.getItem("byTrip");
        if (bytrip && bytrip != null && bytrip != undefined) {
          var ItemsPerformance = this.$store.state.itemsPerformanceInfo;
          if (ItemsPerformance == null) {
            ItemsPerformance = await this.$store.dispatch(
              "getItemPouchdb",
              "ItemsPerformance"
            );
          }
          //  var ItemsPerformance = JSON.parse(
          //    localStorage.getItem("ItemsPerformance")
          // );
          this.$store.commit("viewSkeletonsP", true);
          this.$store.dispatch("destroyPerformanceCharts");
          this.$store.dispatch("divideData", {
            itemsPerformance1: ItemsPerformance,
            comparative: false,
            byTrip: false
          });
        } else {
          this.$store.commit("snackbar", {
            snackbar: true,
            text: i18n.t("noTripSelected")
          });
        }

        localStorage.setItem("byTrip", false);
      }
    },
    goToComparative() {
      if (
        this.$store.state.listOfTrips.length > 2 &&
        this.$store.state.listOfTrips[1] != this.$t("noTrips")
      ) {
        this.$router.push({ name: "comparative" });
      } else {
        this.$store.commit("snackbar", {
          snackbar: true,
          text: i18n.t("noTrips")
        });
      }
    },
    async toExcelData() {
      //   var ItemsPerformance = JSON.parse(
      //     localStorage.getItem("ItemsPerformance")
      // );
      var ItemsPerformance = this.$store.state.itemsPerformanceInfo;
      if (ItemsPerformance == null) {
        ItemsPerformance = await this.$store.dispatch(
          "getItemPouchdb",
          "ItemsPerformance"
        );
      }
      this.$store.dispatch("downloadExcelJson", ItemsPerformance);
    }
  }
};
</script>

<style>
@import "./../assets/styles/skeletons.css";

.highcharts-color-personalized-0 {
  fill: #000000;
  stroke: #000000;
}

.highcharts-color-personalized-F {
  fill: #ffffff;
  stroke: #ffffff;
}

.highcharts-figure,
.highcharts-data-table table {
  min-width: 320px;
  max-width: 1800px;
  margin: 1em auto;
}
.tableIntransit > .v-data-table__wrapper > table > tbody > tr :hover {
  cursor: pointer;
}

/* .chart {
  height: 220px;
} */

.highcharts-data-table table {
  font-family: Verdana, sans-serif;
  border-collapse: collapse;
  border: 1px solid #ebebeb;
  margin: 10px auto;
  text-align: center;
  width: 100%;
  max-width: 1500px;
}
.highcharts-data-table caption {
  padding: 1em 0;
  font-size: 1.2em;
  color: #555;
}
.highcharts-data-table th {
  font-weight: 600;
  padding: 0.5em;
}
.highcharts-data-table td,
.highcharts-data-table th,
.highcharts-data-table caption {
  padding: 0.5em;
}
.highcharts-data-table thead tr,
.highcharts-data-table tr:nth-child(even) {
  background: #f8f8f8;
}
.highcharts-data-table tr:hover {
  background: #f1f7ff;
}

.chart {
  /* min-width: 420px;
  max-width: 900px;
  height: 220px; */
  margin: 0 auto;
}
</style>
